// The bridge must exist before any UI module reads window.dts.
import './bridge/web-bridge';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

window.addEventListener('error', (e) => console.error(`Uncaught: ${e.message}`, e.error?.stack ?? ''));
window.addEventListener('unhandledrejection', (e) => console.error(`Unhandled promise rejection: ${e.reason instanceof Error ? `${e.reason.message}
${e.reason.stack}` : String(e.reason)}`));

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
